import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Navigate } from "react-router-dom";
import { CreateUserModalStyled } from "./create-user-modal.style";
import UserInfoForm, { USER_INFO_FORM_VIEW_TYPES } from "../users-info-form";
import { formatDate } from "../../../../utils/utils";
import { usersCollection } from "../../../../services/firebase";
import { useAuth } from "../../../../context/AuthContext";
import { Typography } from "@mui/material";
import { CreateUserValidations } from "../../../../constants/validations";
import { yupResolver } from "@hookform/resolvers/yup";
import { v4 as uuidv4 } from "uuid"; // Import UUID generator

const CreateUserModal = (props) => {
  const { onClose, defaultValues = {} } = props;
  const { userDetails } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [redirectPath, setRedirectPath] = useState(null);

  const form = useForm({
    mode: "all",
    defaultValues: {
      firstName: "",
      surname: "",
      email: "",
      role: "",
      fullName: "",
      serviceGroup: "",
      permissions: "",
      employmentStatus: "",
      rate: "",
      cost: "",
      title: "",
      startDate: "",
      endDate: "",
      workSchedule: [
        { day: "Monday", hours: 0 },
        { day: "Tuesday", hours: 0 },
        { day: "Wednesday", hours: 0 },
        { day: "Thursday", hours: 0 },
        { day: "Friday", hours: 0 },
      ],
      userNotes: "",
      timezone: "",
      weeklyHours: "",
      ...defaultValues,
    },

    resolver: yupResolver(CreateUserValidations()),
  });

  const { formState, getValues } = form;
  const { isValid } = formState;

  const handleSaveModal = async (data) => {

    const formData = { ...data, firstName: data.firstName.trim(), surname: data.surname.trim() };
    console.log("Received form data:", formData);
    setIsLoading(true);
    try {
      const docId = `${formData.firstName.replace(
        /\s+/g,
        "_"
      )}_${formData.surname.replace(/\s+/g, "_")}`;
      const formattedDate = formatDate(new Date(), "M/d/yyyy");

      formData.createdBy = userDetails?.fullName;
      formData.dateCreated = formattedDate;
      const formattedStartDate = formData.startDate
        ? formatDate(new Date(formData.startDate), "M/d/yyyy")
        : "";

      const userData = {
        id: uuidv4(), // UUID
        firstName: formData.firstName,
        surname: formData.surname,
        email: formData.email,
        role: formData.role,
        serviceGroup: formData.serviceGroup,
        startDate: formattedStartDate,
        permissions: formData.permissions,
        employmentStatus: formData.employmentStatus,
        rate: formData.rate,
        cost: formData.cost,
        title: formData.title,
        workSchedule: formData.workSchedule,
        userNotes: formData.userNotes,
        createdBy: formData.createdBy,
        dateCreated: formattedDate,
        timezone: formData.timezone,
        weeklyHours: formData.weeklyHours,
      };

      const userRef = usersCollection.doc(docId);
      await userRef.set(userData);

      console.log("User saved successfully:", userData);
      onSuccess(docId);
    } catch (error) {
      console.error("Error saving user:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = () => {
    const formData = getValues();
    handleSaveModal(formData);
  };

  const onSuccess = (docId) => {
    setRedirectPath(`/admin-console/${docId}/details`);
    onClose(); // Close modal
  };

  if (redirectPath) {
    return <Navigate to={redirectPath} />;
  }

  return (
    <CreateUserModalStyled
      confirmBtnTitle="Create User"
      confirmBtnColor="#77E250"
      closeBtnTitle="Cancel"
      isConfirming={isLoading}
      disableConfirmBtn={!isValid}
      onConfirm={handleSubmit}
      onClose={onClose}
    >
      <div>
        <div className="head">
          <Typography variant="h4">Create User</Typography>
        </div>
        <UserInfoForm form={form} view={USER_INFO_FORM_VIEW_TYPES.creation} />
      </div>
    </CreateUserModalStyled>
  );
};

export default CreateUserModal;
